import { Deal } from "./deal";
import { Query } from "./http";

export type TitleIssue = {
  createdAt: string;
  data: FormState;
  _id: string;
};

export interface FormState {
  dealId: string;
  deal?: Deal;
  info: Info;
}

export type TitleIssueStatus = "awaiting" | "pending" | "resolved" | "rejected";

export type TitleDocumentInfo = {
  documents: string[];
  WFDDocumentUsed: boolean;
  status: TitleIssueStatus;
  uploadedDate?: string;
};
export type DmvStatus =
  | "titled"
  | "untitled"
  | "error"
  | "old_title"
  | "not_checked";

export type ExternalDmvStatus = "Titled" | "Untitled" | "Not checked";
type DmvInfo = {
  message?: string;
  status: DmvStatus;
  titledDate?: string;
  titleImageUrl?: string;
};

export type LienInfo = {
  hasLien: boolean;
  lienholderName: string | null;
  lienholderAddress: string | null;
  receivedDate: string | null;
  checkedAt: string;
};

export interface Info {
  lastCheckedDate?: string;
  lastTaskNumber?: number;
  receiptInfo: TitleDocumentInfo;
  titleRegistrationInfo: TitleDocumentInfo;
  oldTitleRegistrationInfo: TitleDocumentInfo;
  dmvInfo: DmvInfo;
  lienInfo?: LienInfo;
}
export const getDmvStatus = (dmvStatus?: DmvStatus): ExternalDmvStatus =>
  dmvStatus === "titled"
    ? "Titled"
    : dmvStatus === "not_checked"
    ? "Not checked"
    : "Untitled";

export type TitleIssueStatusCounts = {
  dmvStatus: Record<ExternalDmvStatus, number>;
  documentStatus: Record<StatusType | "not required", number>;
};

export type TitleQuery =
  | {
      active: ExternalDmvStatus;
      query?: { [maybeAnd: string]: Query | string };
    }
  | undefined;

export type TitleDocumentQuery =
  | {
      active: StatusType;
      query?: { [maybeAnd: string]: Query | string };
    }
  | undefined;
export type StatusType = "awaiting" | "incomplete" | "resolved";
